import styled from 'styled-components';

export const Content = ({
	points,
	maxPoints,
	type
}: ContentProps): JSX.Element => {
	return (
		<ContentWrapper>
			{points / maxPoints < 1 && (
				<p>
					<NumberSpan>{maxPoints - (points % maxPoints)}</NumberSpan>{' '}
					more points until your free {type}s reward
				</p>
			)}
			{points / maxPoints >= 1 && (
				<p>Your next {type} order will earn a reward</p>
			)}
		</ContentWrapper>
	);
};

interface ContentProps {
	points: number;
	maxPoints: number;
	type: string;
}

const ContentWrapper = styled.div`
	display: flex;
	flex-direction: column;
	align-items: center;
	justify-content: center;
	text-align: center;
	* {
		color: #575757;
		font-weight: bold;
		font-size: 16px;
		line-height: 140%;
		margin: 0;
	}
`;

const NumberSpan = styled.span<NumberProps>`
	color: ${props => (props.$color ? props.$color : '#f47920')};
	font-size: 18px;
	line-height: 100%;
`;

interface NumberProps {
	$color?: string;
}
